export { default as RootLayoutErrorBoundary } from '@/error-boundaries/RootLayoutErrorBoundary'
